<template>
  <div
    style="font-family: 'Ubuntu', sans serif !important"
    class="outside-print"
  >
    <v-app-bar class="nav" app color="primary" dark elevation="0">
      <div class="content-nav">
        <v-app-bar-nav-icon @click="openDrawer" style="z-index: 10">
          <img
            src="../../assets/icons/menu.svg"
            style="max-height: 12px"
            contain
          />
        </v-app-bar-nav-icon>

        <v-toolbar-title class="d-sm-flex align-center d-none">
          <img
            src="../../assets/fix_logo.svg"
            alt="Equipacare"
            style="max-height: 26px"
            contain
          />
        </v-toolbar-title>

        <v-spacer />

        <div v-if="institution.userType != 6">
          <v-badge
            v-if="chat.notReadedMessages && chat.notReadedMessages.length > 0"
            right
            overlap
            :content="chat.notReadedMessages.length"
            color="secondary"
            dot
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  @click="openChat"
                  icon
                  text
                  style="z-index: 10"
                  small
                >
                  <v-icon> mdi-chat-alert-outline </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Chat de suporte') }}</span>
            </v-tooltip>
          </v-badge>

          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="openChat"
                icon
                text
                style="z-index: 10"
                small
              >
                <v-icon> mdi-chat-alert-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Chat de suporte') }}</span>
          </v-tooltip>
        </div>

        <div
          class="d-flex align-center"
          v-show="institution.userType < 4 || institution.userType == 8"
          style="min-width: 120px; z-index: 10"
        >
          <v-badge
            v-if="alertQuantity > 0"
            left
            overlap
            offset-y="23"
            offset-x="23"
            :content="alertQuantity"
          >
            <v-btn icon @click="alertList = true">
              <v-icon small>mdi-bell-ring-outline</v-icon>
            </v-btn>
          </v-badge>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="$emit('openNotes')">
                <v-icon>mdi-sticker-check-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Últimas atualizações') }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="alertQuantity === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on"> mdi-bell-outline </v-icon>
            </template>
            <span>{{ $t('Nenhum alerta atrasado') }}</span>
          </v-tooltip>

          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                plain
                text
                style="font-size: 0.8rem"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="#fff">mdi-link</v-icon>
              </v-btn>
            </template>

            <v-list
              v-show="user.mainType == 0 || user.mainType == 1"
              width="100%"
              color="#f5f5f5"
              nav
              dense
            >
              <v-list-item-group
                v-model="group"
                active-class="info--text text--accent-2"
              >
                <v-list-item
                  v-for="header in headersLink"
                  :key="header.url"
                  :to="
                    header.title !== 'Gerenciador Equipamento Padrão' ||
                    header.title !== 'Equipamentos Padrão'
                      ? header.url
                      : ''
                  "
                  :href="
                    header.title === 'Gerenciador Equipamento Padrão' ||
                    header.title === 'Equipamentos Padrão'
                      ? header.url
                      : ''
                  "
                  v-show="hasAccess(header.access, header.title)"
                  width="100%"
                >
                  <v-list-item-icon>
                    <v-icon>{{ header.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ $t(header.title) }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <ChangeLocale />
        </div>
      </div>
      <v-img
        src="../../assets/barGraph.svg"
        alt="Hive"
        style="position: absolute; right: 0; top: 0"
      >
      </v-img>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      width="320"
      color="primary"
      class="nav-bar"
    >
      <div>
        <v-img
          src="../../assets/nav-bar.svg"
          style="position: absolute; height: 100%; z-index: 0"
        >
        </v-img>

        <!-- AQUI PARTE DO TIMEZONE -->
        <div class="px-5 pt-6 pb-2">
          <div class="d-flex align-center">
            <v-avatar class="mx-4" color="accent" size="65">
              <v-img
                :max-width="user.profileImage ? '100%' : '35%'"
                contain
                :src="
                  user.profileImage
                    ? user.profileImage
                    : '/img/icons/person-icon.svg'
                "
              ></v-img>
            </v-avatar>
            <div style="z-index: 2">
              <strong class="nav-title">{{ user.name }}</strong>
              <span class="nav-subtitle">
                Nível no Sistema: {{ $t(mainLevels[user.mainType]) }}
                <br />
                Nível na Instituição: {{ $t(levels[institution.userType]) }}
              </span>
              <br />
              <strong class="nav-title mt-2">{{ institution.name }}</strong>
              <span class="nav-subtitle">
                {{ $t('Fuso horário') }}: {{ timeZone }} {{ time }}
              </span>
            </div>
          </div>
        </div>

        <v-container
          class="z-indexs content-nav"
          style="display: flex; justify-content: space-evenly"
        >
          <TPolygonButton color="#B9CE1E">
            <v-btn
              :disabled="institution.userType > 3 && institution.userType != 8"
              @click="callAlerts"
              icon
              plain
              text
              color="white"
            >
              <v-icon>mdi-bell-outline</v-icon>
            </v-btn>
          </TPolygonButton>

          <TPolygonButton color="#426483">
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="
                    institution.userType > 3 && institution.userType != 8
                  "
                  icon
                  plain
                  text
                  style="font-size: 0.8rem"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="#fff">mdi-cog-outline</v-icon>
                </v-btn>
              </template>

              <v-list
                v-show="institution.userType < 3 || institution.userType == 8"
                width="100%"
                color="#f5f5f5"
                nav
                dense
              >
                <v-list-item-group>
                  <v-list-item
                    v-if="institution.workshopType == 1"
                    active-class="black--text text--black-2"
                    to="/workshops"
                    v-show="hasAccess([0, 1, 2, 7, 8])"
                    width="100%"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-clipboard-text</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Oficinas</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    active-class="black--text text--black-2"
                    v-for="header in headersConfig"
                    :key="header.url"
                    :to="
                      header.title !== 'Gerenciador Equipamento Padrão' ||
                      header.title !== 'Equipamentos Padrão'
                        ? header.url
                        : ''
                    "
                    :href="
                      header.title === 'Gerenciador Equipamento Padrão' ||
                      header.title === 'Equipamentos Padrão'
                        ? header.url
                        : ''
                    "
                    v-show="hasAccess(header.access, header.title)"
                    width="100%"
                  >
                    <v-list-item-icon>
                      <v-icon>{{ header.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{
                      $t(header.title)
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </TPolygonButton>

          <TPolygonButton color="#2A8EA4">
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  plain
                  text
                  style="font-size: 0.8rem"
                  color="white"
                  v-on="on"
                  v-bind="attrs"
                >
                  <v-img
                    src="../../assets/figmaIcons/white/supplier.svg"
                    max-width="46%"
                    contain
                  ></v-img>
                </v-btn>
              </template>

              <v-list width="100%" color="#f5f5f5" nav dense>
                <v-list-item-group>
                  <v-list-item
                    active-class="black--text text--black-2"
                    v-for="header in headersUser"
                    :target="header.drive ? '_blank' : ''"
                    :key="header.url"
                    :to="header.drive ? '' : header.url"
                    :href="header.drive ? header.url : ''"
                    v-show="hasAccess(header.access, header.title)"
                    width="100%"
                  >
                    <v-list-item-icon>
                      <v-img
                        v-if="header.isImage"
                        :src="
                          require(`../../assets/figmaIcons/blue/${header.icon}`)
                        "
                        width="20"
                        contain
                      ></v-img>
                      <v-icon v-else color="primary">{{ header.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{
                      $t(header.title)
                    }}</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="logout"
                    active-class="black--text text--black-2"
                    width="100%"
                  >
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </TPolygonButton>
        </v-container>

        <v-list nav dense class="mt-4 pb-0" dark>
          <template v-for="header in headers">
            <v-list-group
              no-action
              v-if="
                header.routes &&
                header.routes.length > 0 &&
                hasAccess(header.access, header.title)
              "
              :key="header.icon"
              class="nav-item"
            >
              <template v-slot:activator>
                <div
                  active-class="nav-active"
                  class="rounded-0 d-flex align-center"
                  link
                  style="width: 100%"
                >
                  <v-list-item-icon class="mr-4">
                    <v-img
                      v-if="!header.isIcon"
                      :src="
                        require(`../../assets/figmaIcons/white/${header.icon}`)
                      "
                      max-width="24"
                      contain
                    ></v-img>
                    <v-icon color="white" v-else>
                      {{ header.icon }}
                    </v-icon>
                  </v-list-item-icon>
                  <span style="color: white" class="flex-grow-1">{{
                    $t(header.title)
                  }}</span>

                  <v-badge
                    class="mr-6"
                    color="secondary"
                    offset-y="10"
                    v-show="header.title === 'Relatórios'"
                    v-if="tecnoAlertQuantity"
                    :content="tecnoAlertQuantity"
                  >
                  </v-badge>
                </div>
              </template>
              <div style="margin-left: 58px">
                <template v-for="c in header.routes">
                  <v-list-group
                    no-action
                    v-if="
                      c.routes &&
                      c.routes.length > 0 &&
                      hasAccess(c.access, c.title)
                    "
                    :key="c.icon"
                    sub-group
                    prepend-icon=""
                    append-icon="mdi-chevron-down"
                    class="nav-item"
                  >
                    <template v-slot:activator>
                      <div
                        active-class="nav-active"
                        class="rounded-0 d-flex align-center"
                        link
                        style="width: 100%"
                      >
                        <span style="color: white" class="flex-grow-1">{{
                          $t(c.title)
                        }}</span>

                        <v-icon>mdi-chevron-down</v-icon>
                      </div>
                    </template>
                    <div style="margin-left: 58px">
                      <template v-for="r in c.routes">
                        <v-list-item
                          active-class="nav-active"
                          class="nav-item d-flex align-center"
                          style="
                            border-bottom: 0.4px solid #e7eaeb;
                            border-radius: 0;
                          "
                          :key="r.title"
                          :to="r.route"
                          v-if="r.title && hasAccess(r.access, r.title)"
                          exact
                        >
                          <span style="color: white" class="mr-6">{{
                            $t(r.title)
                          }}</span>

                          <v-badge
                            class="mr-6"
                            color="secondary"
                            overlap
                            left
                            offset-x="10"
                            offset-y="10"
                            v-show="r.title === 'Alertas de Tecnovigilância'"
                            v-if="tecnoAlertQuantity"
                            :content="tecnoAlertQuantity"
                          ></v-badge>
                        </v-list-item>
                      </template>
                    </div>
                  </v-list-group>

                  <v-list-item
                    v-if="hasAccess(c.access, c.title) && !c.routes"
                    active-class="nav-active"
                    class="nav-item d-flex align-center"
                    style="border-bottom: 0.4px solid #e7eaeb; border-radius: 0"
                    :key="c.title"
                    :to="c.route"
                    exact
                  >
                    <span style="color: white" class="mr-6 ml-4">{{
                      $t(c.title)
                    }}</span>

                    <v-badge
                      class="mr-6"
                      color="secondary"
                      overlap
                      left
                      offset-x="10"
                      offset-y="10"
                      v-show="c.title === 'Alertas de Tecnovigilância'"
                      v-if="tecnoAlertQuantity"
                      :content="tecnoAlertQuantity"
                    ></v-badge>
                  </v-list-item>
                </template>
              </div>
            </v-list-group>

            <v-list-item
              v-if="hasAccess(header.access, header.title) && !header.routes"
              :key="header.title"
              active-class="nav-active"
              class="nav-item rounded-0 d-flex align-center"
              link
              :to="header.route"
            >
              <v-list-item-icon class="mr-4">
                <v-img
                  v-if="!header.isIcon"
                  :src="require(`../../assets/figmaIcons/white/${header.icon}`)"
                  max-width="24"
                  contain
                ></v-img>
                <v-icon color="white" v-else>
                  {{ header.icon }}
                </v-icon>
              </v-list-item-icon>
              <span style="color: white" class="mr-6">
                {{ $t(header.title) }}
              </span>

              <v-badge
                class="mr-6"
                color="secondary"
                overlap
                left
                offset-x="10"
                offset-y="10"
                v-show="header.title === 'Chamados'"
                v-if="
                  calledQuantity &&
                  (institution.userType < 4 || institution.userType == 8)
                "
                :content="calledQuantity"
              ></v-badge>
            </v-list-item>
          </template>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="alertList"
      right
      app
      temporary
      color="primary"
    >
      <v-list>
        <v-list-item>
          <v-icon color="#fff" class="mr-5">mdi-bell-outline</v-icon>
          <v-list-item-title style="color: #fff; font-size: 1.2rem">{{
            $t('Alertas atrasados')
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item v-for="alert in alerts" :key="alert.id" href="/alert">
          <v-card width="100%" class="my-2">
            <v-card-text
              style="font-size: 0.9rem"
              class="d-flex justity-content-center align-center"
            >
              <v-icon class="mr-5">
                {{ alertIcon(alert.alertModule) }}
              </v-icon>
              <div>
                <span class="d-block">{{ alert.description }}</span>
                <span style="font-size: 0.8rem">{{
                  parseDatetime(alert.alertDateTime)
                }}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import ApiService from '../../services/ApiService'
import Utils from '../../Utils/FormatDate'
import TPolygonButton from '../../components/T/TPolygonButton.vue'
import ChangeLocale from '../../components/ChangeLocale.vue'
import sound from '../../assets/sounds/fixalert.wav'

export default {
  props: {
    chatIsOpen: Boolean,
  },

  data: () => ({
    localChatIsOpen: false,
    chat: {
      notReadedMessages: [],
    },
    socket: null,
    tecnoAlertQuantity: 0,
    drawer: false,
    alertList: false,
    group: null,
    profileImage: null,
    time: null,
    timeZone: null,
    alertQuantity: 0,
    calledQuantity: 0,
    user: {},
    institution: {},
    alerts: [],
    headers: [
      {
        icon: 'dash.svg',
        title: 'Cadastro Padrão',
        access: [0],
        route: '',
        module: null,
        routes: [
          {
            title: 'Gerenciador de Equipamento Padrão',
            route: '/standardEquipments?fromAdmin=1',
            access: [0],
          },
          {
            title: 'Repositório de Arquivos - Estrutura de Pastas',
            route: '/standardFilesRepository',
            access: [0],
          },
          {
            title: 'Fabricantes Padrão',
            route: '/standard-manufacturer',
            access: [0],
          },
          {
            title: 'Checklist Padrão',
            route: '/standardChecklist',
            access: [0],
          },
          {
            title: 'Métricas de Calibração',
            route: '/calibrationMetrics',
            access: [0],
          },
          {
            title: 'Métricas de Calibração (V2)',
            route: '/calibration/v2/metric',
            access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
          },
          {
            title: 'Template de Calibração (V2)',
            route: '/calibration/v2/template',
            access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
          },
        ],
      },
      {
        access: [0, 1],
        icon: 'equips.svg',
        title: 'Equipamentos',
        module: 'equipamentos',
        route: '/equipment',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
      },
      {
        icon: 'servOrder.svg',
        title: 'Ordem de Serviço',
        module: 'ordem_de_servico',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
        route: '/serviceorders',
      },
      {
        icon: 'called.svg',
        title: 'Chamados',
        module: 'chamados',
        route: '/calleds',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
      },
      {
        icon: 'mdi-tools',
        title: 'Manutenção Programada',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
        route: '',
        module: null,
        routes: [
          {
            title: 'Checklist',
            route: '/standardFilesRepository',
            access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
          },
          {
            title: 'Segurança Elétrica',
            route: '/electricalSafety',
            access: [0, 1, 2],
          },
          {
            title: 'Calibração',
            route: '/calibration',
            access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
          },
          {
            title: 'Calibração V2',
            route: '/calibration/v2',
            access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
          },
        ],
      },
      {
        isIcon: true,
        icon: 'mdi-water-outline',
        title: 'Controle de Consumo',
        route: '/consumption',
        access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
      },
      {
        icon: 'stock.svg',
        title: 'Estoque',
        module: 'estoque',
        route: '/stock',
        access: [0, 1, 2, 7, 8, 3, 4],
      },
      {
        icon: 'reports.svg',
        title: 'Relatórios',
        module: 'relatorios',
        access: [0, 1, 2, 7, 8, 3, 4, 5],
        route: '',
        routes: [
          {
            title: 'Logs',
            route: '/logs',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
          {
            title: 'Dashboard',
            route: '/dashboard',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
          {
            title: 'Dashboard - BI',
            route: '/dashboard-bi',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
          {
            title: 'Indicadores',
            route: '/reports',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
          {
            title: 'Estudo de Substituição',
            route: '/replaceStudy',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
          {
            title: 'Alertas de Tecnovigilância',
            route: '/tecnovigilancia',
            access: [0, 1, 2, 7, 8, 3, 4, 5],
          },
        ],
      },
      {
        icon: 'calendar.svg',
        title: 'Agendamentos',
        module: 'agendamentos',
        access: [0, 1, 2, 7, 5, 8, 3, 4],
        route: '',
        routes: [
          {
            title: 'Calendário',
            route: '/calendar',
            access: [0, 1, 2, 7, 5, 8, 3, 4],
          },
          {
            title: 'Cronograma',
            route: '/chronogram',
            access: [0, 1, 2, 7, 5, 8, 3, 4],
          },
        ],
      },
      {
        icon: 'contracts.svg',
        title: 'Repositório de Arquivos',
        module: 'filesRepository',
        route: '/filesRepository',
        access: [0, 1, 2, 7, 8, 3],
      },
      {
        icon: 'big-data.svg',
        title: 'Big Data',
        module: 'big_data',
        route: '/big-data',
        access: [0, 1, 2, 7, 8, 4],
      },
      {
        icon: 'patchnotes.svg',
        title: 'Notas de Atualização',
        module: 'notas_de_atualizacao',
        route: '/patchNotes',
        access: [0],
      },
      {
        icon: 'users.svg',
        title: 'Usuários',
        module: 'users',
        route: '/users',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'import.svg',
        title: 'Importar',
        module: 'importar_equipamentos',
        access: [0, 1, 2, 7, 8],
        route: '',
        routes: [
          {
            title: 'Equipamentos',
            route: '/equipmentImport',
            access: [0, 1, 2, 7, 5, 8, 3, 4],
          },
          {
            title: 'Setor',
            route: '/importDepartment',
            access: [0, 1, 2, 7, 5, 8, 3, 4],
          },
        ],
      },
      {
        icon: 'supplier.svg',
        title: 'Fornecedores',
        module: 'fornecedores',
        route: '/suppliers',
        access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
      },
      {
        icon: 'contracts.svg',
        title: 'Contratos',
        module: 'contratos',
        route: '/contracts',
        access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
      },
      {
        icon: 'tasks.svg',
        title: 'Tarefas',
        module: 'tarefas',
        route: '/tasks',
        access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
      },
    ],
    mainLevels: ['Master', 'Administrador', 'Usuário'],
    levels: [
      'Supervisor',
      'Supervisor',
      'Supervisor',
      'Operador',
      'Coordenador Op.',
      'Coordenador Setor Assistencial',
      'Solicitador',
      'Laboratório',
      'Supervisor Principal',
    ],
    apiService: new ApiService(),
    headersConfig: [
      {
        icon: 'mdi-file-chart-outline',
        title: 'SLA`s',
        url: '/slas',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-auto-fix',
        title: 'Soluções Defeito',
        url: '/solutions',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-sticker-plus-outline',
        title: 'Setores',
        url: '/departments',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-wrench-outline',
        title: 'Equipamentos padrão',
        url: '/standardEquipments?fromAdmin=0',
        access: [0, 1, 2, 7, 8],
      },

      {
        icon: 'mdi-factory',
        title: 'Fabricantes',
        url: '/manufacturer',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
      },
      {
        icon: 'mdi-office-building-outline',
        title: 'Unidade',
        url: '/unidades',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-city-variant-outline',
        title: 'Instituições',
        url: '/institutions',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-city-variant-outline',
        title: 'Centro de custo',
        url: '/costCenter',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-google-analytics',
        title: 'Analisadores',
        url: '/analysers',
        access: [0],
      },
    ],
    headersLink: [
      {
        icon: 'mdi-file-link-outline',
        title: 'Arquivos externo controle',
        url: '/externalFileControl',
        access: [0, 1, 2, 7, 8],
      },
      {
        icon: 'mdi-calendar-month-outline',
        title: 'Calendário',
        url: '/calendar',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
      },
    ],
    headersUser: [
      {
        isImage: true,
        icon: 'perfil.svg',
        title: 'Minha conta - preferências',
        url: '/userProfile',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
      },
      {
        inst: true,
        icon: 'mdi-eye-outline',
        title: 'Alterar visão de instituição',
        url: '/changeInstitution',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
      },
      {
        icon: 'mdi-video',
        title: 'Vídeos',
        url: '/videos',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
      },
      {
        icon: 'reports.svg',
        title: 'POPs',
        url: 'http://localhost:8080/filesRepository?tab=6',
        access: [0, 1, 2, 7, 8, 3, 4],
      },
      {
        icon: 'standequip.svg',
        title: 'Manuais Equipamentos',
        url: 'http://localhost:8080/filesRepository?tab=5',
        access: [0, 1, 2, 7, 8, 3],
      },
      {
        drive: true,
        icon: 'mdi-file-document',
        title: 'Política de Privacidade',
        url: 'https://eqpfixapi.azurewebsites.net/privacidade.pdf',
        access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
      },
    ],
    mesRing: null,
    institutionSocket: null,
    fetchIntervalFn: null,
    calledSocket: null,
    alertSound: new Audio(require('../../assets/sounds/tindeck_1.mp3')),
  }),

  components: {
    TPolygonButton,
    ChangeLocale,
  },

  computed: {},

  created() {
    this.initialize()

    this.$root.$on('update', () => {
      this.mainKey = !this.mainKey
      this.initialize()
    })
  },

  beforeDestroy() {
    if (this.fetchIntervalFn) {
      clearInterval(this.fetchIntervalFn)
    }

    if (this.socket) this.socket.close()
    if (this.institutionSocket) this.institutionSocket.close()
  },

  methods: {
    initialize() {
      this.headers = [
        {
          icon: 'dash.svg',
          title: 'Cadastro Padrão',
          access: [0],
          route: '',
          module: null,
          routes: [
            {
              title: 'Gerenciador de Equipamento Padrão',
              route: '/standardEquipments?fromAdmin=1',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Repositório de Arquivos - Estrutura de Pastas',
              route: '/standardFilesRepository',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Fabricantes Padrão',
              route: '/standard-manufacturer',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Checklist Padrão',
              route: '/standardChecklist',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Métricas de Calibração',
              route: '/calibrationMetrics',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Métricas de Calibração (V2)',
              route: '/calibration/v2/metric',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Template de Calibração (V2)',
              route: '/calibration/v2/standardTemplate',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
          ],
        },
        {
          icon: 'equips.svg',
          title: 'Equipamentos',
        },
        {
          icon: 'equips.svg',
          title: 'Equipamentos',
          module: 'equipamentos',
          route: '/equipment',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
        },
        {
          icon: 'servOrder.svg',
          title: 'Ordem de Serviço',
          module: 'ordem_de_servico',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
          route: '/serviceorders',
        },
        {
          icon: 'called.svg',
          title: 'Chamados',
          module: 'chamados',
          route: '/calleds',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
        },
        {
          icon: 'tools.svg',
          title: 'Manutenção Programada',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
          route: '',
          module: null,
          routes: [
            {
              icon: 'checklist.svg',
              title: 'Checklist',
              module: 'checklist',
              access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
              route: '',
              routes: [
                {
                  title: 'Manutenção Preventiva',
                  route: '/checklists',
                  access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
                },
                {
                  title: 'Rotina de Inspeção',
                  route: '/inspectionRoutineChecklist',
                  access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
                },
              ],
            },
            {
              title: 'Calibração',
              route: '/calibration',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Calibração V2',
              route: '/calibration/v2',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Segurança Elétrica',
              route: '/electricalSafety',
              access: [0, 1],
            },
          ],
        },
        {
          isIcon: true,
          icon: 'mdi-water-outline',
          title: 'Controle de Consumo',
          route: '/consumption',
          access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
        },

        {
          icon: 'stock.svg',
          title: 'Estoque',
          module: 'estoque',
          route: '/stock',
          access: [0, 1, 2, 7, 8, 3, 4],
        },
        {
          icon: 'reports.svg',
          title: 'Relatórios',
          module: 'relatorios',
          access: [0, 1, 2, 7, 8, 3, 4, 5],
          route: '',
          routes: [
            {
              title: 'Logs',
              route: '/logs',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Dashboard',
              route: '/dashboard',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8, 5],
            },
            {
              title: 'Dashboard - BI',
              route: '/dashboard-bi',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Indicadores',
              route: '/reports',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Estudo de Substituição',
              route: '/replaceStudy',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Alertas de Tecnovigilância',
              route: '/tecnovigilancia',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
          ],
        },
        {
          icon: 'calendar.svg',
          title: 'Agendamentos',
          module: 'agendamentos',
          access: [0, 1, 2, 5, 7, 8, 3, 4],
          route: '',
          routes: [
            {
              title: 'Calendário',
              route: '/calendar',
              access: [0, 1, 2, 7, 5, 8, 3, 4, 7, 8],
            },

            {
              title: 'Cronograma',
              route: '/chronogram',
              access: [0, 1, 2, 7, 5, 8, 3, 4, 7, 8],
            },
          ],
        },
        {
          icon: 'contracts.svg',
          title: 'Repositório de Arquivos',
          module: 'filesRepository',
          route: '/filesRepository',
          access: [0, 1, 2, 7, 8, 3],
        },
        {
          icon: 'big-data.svg',
          title: 'Big Data',
          module: 'big_data',
          access: [0, 1, 2, 7, 8, 4],
          route: '',
          routes: [
            {
              title: 'Dados',
              route: '/big-data',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Dashboard',
              route: '/big-data-dashboard',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
          ],
        },
        {
          icon: 'patchnotes.svg',
          title: 'Notas de Atualização',
          module: 'notas_de_atualizacao',
          route: '/patchNotes',
          access: [0],
        },
        {
          icon: 'users.svg',
          title: 'Usuários',
          module: 'users',
          route: '/users',
          access: [0, 1, 2, 7, 8],
        },
        {
          icon: 'import.svg',
          title: 'Importar',
          module: 'importar_equipamentos',
          access: [0, 1, 2, 7, 8],
          route: '',
          routes: [
            {
              title: 'Equipamentos',
              route: '/equipmentImport',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
            {
              title: 'Setor',
              route: '/importDepartment',
              access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
            },
          ],
        },
        {
          icon: 'supplier.svg',
          title: 'Fornecedores',
          module: 'fornecedores',
          route: '/suppliers',
          access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
        },
        {
          icon: 'contracts.svg',
          title: 'Contratos',
          module: 'contratos',
          route: '/contracts',
          access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
        },
        {
          icon: 'tasks.svg',
          title: 'Tarefas',
          module: 'tarefas',
          route: '/tasks',
          access: [0, 1, 2, 7, 8, 3, 4, 7, 8],
        },
      ]

      this.user = JSON.parse(localStorage.getItem('user'))
      this.institution = JSON.parse(localStorage.getItem('institution'))

      this.institution.modules = this.institution.modules
        ? this.institution.modules.split(',')
        : []

      this.headers = this.headers.filter(
        (x) => x.module == null || this.institution.modules.includes(x.module)
      )

      if (this.institution.userType != 0) this.getuserChat()
      else this.notReadedMessages()

      // this.addSocket()
      // this.addInstitutionSocket()
      this.addCalledSocket()

      this.institution = JSON.parse(localStorage.getItem('institution'))
      if (this.user.profileImage != null) {
        this.user.profileImage = this.user.profileImage.includes(
          'https://equipacarefix.blob.core.windows.net/'
        )
          ? this.user.profileImage
          : `${process.env.VUE_APP_BASE_URL}Uploads/Users/${this.user.id}/profileImage/${this.user.profileImage}`
      } else {
        this.user.profileImage = null
      }

      const today = new Date()
      this.time = `${today.getDate()}/${
        today.getMonth() + 1
      }/${today.getFullYear()} ${today.getHours()}:${today.getMinutes()}`

      this.timeZone = today
        .toLocaleString(navigator.language, { timeZoneName: 'short' })
        .split(' ')
        .pop()

      this.getAlertsPending()

      this.getOpenCalled()
      this.fetchIntervalFn = setInterval(() => {
        this.getOpenCalled()
      }, 120000)

      if (!this.institution.showVideos) {
        const idx = this.headersUser.findIndex((x) => x.title == 'Vídeos')
        this.headersUser.splice(idx, 1)
      }

      if (!this.institution.showEngClinic) {
        const idx = this.headersUser.findIndex((x) => x.title == 'POPs')
        this.headersUser.splice(idx, 1)
      }

      if (!this.institution.showManuais) {
        const idx = this.headersUser.findIndex(
          (x) => x.title == 'Manuais Equipamentos'
        )
        this.headersUser.splice(idx, 1)
      }
    },

    addInstitutionSocket() {
      if (this.institutionSocket) {
        return
      }

      this.institutionSocket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=${this.institution.id}&userId=${this.user.id}`
      )

      const $context = this

      this.institutionSocket.onmessage = async function (e) {
        const socketMessage = await JSON.parse(e.data)
        if (
          socketMessage.item &&
          ($context.institution.userType == 1 ||
            $context.institution.userType == 2 ||
            $context.institution.userType == 8 ||
            $context.institution.userType == 3)
        ) {
          $context.$toast(
            `O item ${socketMessage.item.name} atingiu ou ultrapassou a quantidade mínima de ${socketMessage.item.minimumQuantity} unidades no estoque`
          )
        }
      }
    },

    addSocket() {
      if (this.socket) {
        return
      }

      this.socket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=${this.user.id}&userId=${this.user.id}`
      )

      const $context = this

      this.socket.onmessage = async function (e) {
        const socketMessage = await JSON.parse(e.data)

        if (
          socketMessage.entity &&
          $context.user.id != socketMessage.entity.senderId &&
          !$context.localChatIsOpen
        ) {
          $context.chat.notReadedMessages.push(socketMessage.entity)
          $context.$toast(
            `Você tem uma nova mensagem de ${socketMessage.entity.sender.name}`
          )
        }
      }
    },

    addCalledSocket() {
      if (this.calledSocket) {
        return
      }

      const userId = JSON.parse(localStorage.getItem('user')).id
      const institutionId = JSON.parse(localStorage.getItem('institution')).id

      this.calledSocket = new WebSocket(
        `${process.env.VUE_APP_BASE_URL_SOCKET}?chatId=institution-${institutionId}`
      )

      const $context = this

      this.calledSocket.onmessage = async function (e) {
        const audioInCalleds = JSON.parse(
          localStorage.getItem('user')
        ).audioInCalleds
        const socketMessage = await JSON.parse(e.data)
        if (audioInCalleds === true) {
          if (userId !== socketMessage.userRequesterId) {
            const url =
              'https://equipacarefix.blob.core.windows.net/public/tindeck_1.mp3'
            window.AudioContext =
              window.AudioContext || window.webkitAudioContext
            const context = new AudioContext()
            $context.mesRing = context.createBufferSource()
            $context.mesRing.connect(context.destination)
            const request = new XMLHttpRequest()
            request.open('GET', url, true)
            request.responseType = 'arraybuffer'
            request.onload = function () {
              context.decodeAudioData(
                request.response,
                function (response) {
                  $context.mesRing.buffer = response
                  $context.mesRing.start(0)
                  setTimeout(() => {
                    if ($context.mesRing) {
                      $context.mesRing.stop()
                      $context.mesRing = null
                    }
                  }, 1100)
                },
                function () {
                  console.error('The request failed.')
                }
              )
            }
            request.send()

            setTimeout(() => {
              $context.mesRing.stop()
              $context.mesRing = null
            }, 1000)
          }
        }
      }
    },

    notReadedMessages() {
      this.apiService
        .get(`chat/master/notReaded`, null, true, false)
        .then((response) => {
          this.chat.notReadedMessages = response.content
        })
    },

    getuserChat() {
      this.apiService
        .get(`chat/${this.user.id}`, null, true, false)
        .then((response) => {
          this.chat = response.content ? response.content : {}
        })
    },

    openChat() {
      if (this.institution.userType != 0) {
        this.chat.notReadedMessages = []
      }
      this.$root.$emit('chat')
    },

    getAlerts() {
      this.apiService
        .get(
          `tecnovigilancia/unviewed/${this.institution.id}`,
          null,
          true,
          false
        )
        .then((resp) => {
          this.tecnoAlertQuantity = resp.content
        })
    },

    setSessionId() {
      this.apiService.get('user/set-session')
    },

    logout() {
      this.setSessionId()
      localStorage.removeItem('institution')
      localStorage.removeItem('locale')
      localStorage.removeItem('token')
      localStorage.removeItem('expires')
      localStorage.removeItem('user')
      this.$router.push('/auth')
    },

    hasAccess(val, text) {
      if (!val) return
      const result = val.find((type) => {
        if (type < 2) {
          return this.user.mainType == type
        }
        return this.institution.userType == type
      })

      if (
        text === 'Controle de Consumo' &&
        !this.institution.departmentTypes.includes(1)
      ) {
        return false
      }

      if (result == undefined) {
        return false
      } else {
        return true
      }
    },

    callAlerts() {
      if (this.institution.userType > 3 && this.institution.userType < 8) return

      this.$router.push('/alert')
    },

    callUserProfile() {
      this.$router.push('/userProfile')
    },

    async openDrawer() {
      this.institution = JSON.parse(localStorage.getItem('institution'))

      this.drawer = true
      if (
        (this.institution.userType == 2 ||
          this.institution.userType == 8 ||
          this.institution.userType == 4) &&
        this.drawer
      ) {
        this.getAlerts()
      }
    },

    async getAlertsPending() {
      await this.apiService
        .get(`alert/getPending/${this.institution.id}`, null, true, false)
        .then((response) => {
          response.content.map((alert) => {
            if (!this.compareDatetime(alert.alertDateTime)) {
              this.alerts.push(alert)
            }
          })

          this.alertQuantity = this.alerts.length
        })
    },

    compareDatetime(datetime) {
      return Utils.compareDateTime(datetime)
    },

    async getOpenCalled() {
      await this.apiService
        .get(
          `called/listOpenCalledCount/${this.institution.id}`,
          null,
          false,
          false
        )
        .then((response) => {
          this.calledQuantity = response.content
        })
    },

    alertIcon(module) {
      switch (module) {
        case 0:
          return 'mdi-view-module'
        case 1:
          return 'mdi-hammer-screwdriver'
        case 2:
          return 'mdi-file-document-multiple-outline'
        case 3:
          return 'mdi-view-list'
        case 4:
          return 'mdi-math-compass'
      }
    },

    parseDatetime(date) {
      return Utils.dateTime(date)
    },

    workshopAcess(val) {
      if (val === 'Controle de Consumo' && this.institution.workshopType != 1) {
        return false
      } else {
        return true
      }
    },
  },

  watch: {
    chatIsOpen() {
      this.localChatIsOpen = this.chatIsOpen
    },

    drawer() {
      this.getOpenCalled()
      this.institution = JSON.parse(localStorage.getItem('institution'))

      this.headersUser = [
        {
          isImage: true,
          icon: 'perfil.svg',
          title: 'Minha conta - preferências',
          url: '/userProfile',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
        },
        {
          inst: true,
          icon: 'mdi-eye-outline',
          title: 'Alterar visão de instituição',
          url: '/changeInstitution',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
        },
        {
          icon: 'mdi-video',
          title: 'Vídeos',
          url: '/videos',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 7, 8],
        },
        {
          isImage: true,
          icon: 'reports.svg',
          title: 'POPs',
          url: '/filesRepository?tab=6',
          access: [0, 1, 2, 7, 8, 3, 4],
        },
        {
          isImage: true,
          icon: 'standequip.svg',
          title: 'Manuais Equipamentos',
          url: '/filesRepository?tab=5',
          access: [0, 1, 2, 7, 8, 3],
        },
        {
          drive: true,
          icon: 'mdi-file-document',
          title: 'Política de Privacidade',
          url: 'https://eqpfixapi.azurewebsites.net/privacidade.pdf',
          access: [0, 1, 2, 7, 8, 3, 4, 5, 6, 7, 8],
        },
      ]

      if (!this.institution.showVideos) {
        const idx = this.headersUser.findIndex((x) => x.title == 'Vídeos')
        this.headersUser.splice(idx, 1)
      }

      if (!this.institution.showEngClinic) {
        const idx = this.headersUser.findIndex((x) => x.title == 'POPs')
        this.headersUser.splice(idx, 1)
      }

      if (!this.institution.showManuais) {
        const idx = this.headersUser.findIndex(
          (x) => x.title == 'Manuais Equipamentos'
        )
        this.headersUser.splice(idx, 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';

@media print {
  .outside-print {
    display: none;
    height: 0;
    width: 0;
  }
}

.nav-title {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #f1f1f1;
  display: block;
  max-width: 170px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.nav-subtitle {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.15px;
  color: #f1f1f1;
}

.nav {
  overflow: hidden;
  .content-nav {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;

    #btnAlert {
      z-index: 10;
    }

    .hive {
      height: 100%;
      position: absolute;
      right: -45px;
      top: 0px;
      width: 370px;
      // background: black;

      img {
        // transform: rotate(18deg);
        width: 125%;
        height: 125%;
        object-fit: cover;
      }

      @media (max-width: $mobile-1) {
        width: 200px;
        top: -10px;

        img {
          height: 150%;
        }
      }
    }
  }
}

.nav-item {
  border-bottom: 1px solid white;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 0.929rem !important;
  line-height: 16px !important;
  letter-spacing: 0.15px !important;

  color: #b1b1b1 !important;
}

.nav-active {
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  line-height: 15px !important;
  letter-spacing: 0.15px !important;

  color: #f1f1f1 !important;
  background: #1f497d;
}

.nav-bar {
  .z-indexs {
    z-index: 999;
  }

  &::v-deep .v-navigation-drawer__content {
    &::-webkit-scrollbar {
      width: 8px;
      transition: 0.3s !important;
    }

    &::-webkit-scrollbar-track {
      background: #0f3565;
      transition: 0.3s !important;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #426483;
      transition: 0.3s !important;
    }

    &::-webkit-scrollbar-thumb:hover {
      transition: 0.3s !important;
      background: #429699;
    }
  }
}
</style>
